import gql from 'graphql-tag';

export const BRAND_EDIT_TERMS_MUTATION = gql`
mutation BrandEditTermsMutation($programId: Int!, $memberDetails: TermsMemberDetailsInput!, $projectInput: TermsProjectInput!) {
  success: brandEditTerms(programId: $programId, memberDetails: $memberDetails, projectInput: $projectInput)
  }
`;
